import { Box, useMultiStyleConfig, VStack } from '@chakra-ui/react';
import React from 'react';

import { Text } from '../../Text';

interface HeaderCardProps {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  header: string;
  colorScheme: 'blue' | 'red';
}

const HeaderCard: React.FC<HeaderCardProps> = ({
  header,
  as,
  colorScheme,
  children,
}) => {
  const Styles = useMultiStyleConfig('HeaderCard', { colorScheme });

  return (
    <VStack sx={Styles.card}>
      <Box sx={Styles.header}>
        <Text as={as}>{header}</Text>
      </Box>
      <Box sx={Styles.content}>{children}</Box>
    </VStack>
  );
};

export default HeaderCard;
